export const LOGOUT_STATUS_ERRORS = [401, 403]
